import { Navigate } from "react-router-dom";
import { FunctionComponent, ReactElement } from "react";
import { User, UserType } from "./types";

interface RouteGuardProps {
  currentUser: User | null;
  allowedUserTypes: UserType[];
  children: ReactElement;
}

export const RouteGuard: FunctionComponent<RouteGuardProps> = ({
  currentUser,
  allowedUserTypes,
  children,
}) => {
  return allowedUserTypes.includes(currentUser?.userType as UserType) ? (
    children
  ) : (
    <Navigate to="/" replace />
  );
};

const defaultLinkMap: Record<UserType, string> = {
  BO_ADMIN: "/task-creation",
};

export const getDefaultLink = (user: User | null): string =>
  user?.userType ? defaultLinkMap[user.userType] || "/" : "/";
